import { render, staticRenderFns } from "./communicationList.vue?vue&type=template&id=626f8bf0&scoped=true"
import script from "./communicationList.vue?vue&type=script&lang=js"
export * from "./communicationList.vue?vue&type=script&lang=js"
import style0 from "./communicationList.vue?vue&type=style&index=0&id=626f8bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f8bf0",
  null
  
)

export default component.exports